import { useTranslation } from 'react-i18next';

export default function WhatWeDo() {
  const { t } = useTranslation();

  const pillars = [
    {
      icon: 'ri-code-s-slash-line',
      title: t('whatWeDoPillar1Title'),
      description: t('whatWeDoPillar1Description'),
      features: [
        t('whatWeDoPillar1Feature1'),
        t('whatWeDoPillar1Feature2'),
        t('whatWeDoPillar1Feature3'),
        t('whatWeDoPillar1Feature4'),
      ],
    },
    {
      icon: 'ri-settings-3-line',
      title: t('whatWeDoPillar2Title'),
      description: t('whatWeDoPillar2Description'),
      features: [
        t('whatWeDoPillar2Feature1'),
        t('whatWeDoPillar2Feature2'),
        t('whatWeDoPillar2Feature3'),
        t('whatWeDoPillar2Feature4'),
      ],
    },
    {
      icon: 'ri-rocket-line',
      title: t('whatWeDoPillar3Title'),
      description: t('whatWeDoPillar3Description'),
      features: [
        t('whatWeDoPillar3Feature1'),
        t('whatWeDoPillar3Feature2'),
        t('whatWeDoPillar3Feature3'),
        t('whatWeDoPillar3Feature4'),
      ],
    },
  ];

  return (
    <section id="what-we-do" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-[rgb(0,0,139)]/10 rounded-full px-4 py-2 mb-4">
            <span className="text-[rgb(0,0,139)] text-sm font-semibold">{t('whatWeDoTag')}</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            <strong>{t('whatWeDoTitle')}</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('whatWeDoDescription')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {pillars.map((pillar, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-2xl p-8 hover:bg-white hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer group border border-transparent hover:border-gray-100"
            >
              <div className="w-16 h-16 bg-[rgb(0,0,139)]/10 rounded-xl flex items-center justify-center mb-6 group-hover:bg-[rgb(0,0,139)] transition-colors duration-300">
                <i className={`${pillar.icon} text-2xl text-[rgb(0,0,139)] group-hover:text-white transition-colors duration-300`}></i>
              </div>

              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                {pillar.title}
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                {pillar.description}
              </p>

              <ul className="space-y-3">
                {pillar.features.map((feature, fIndex) => (
                  <li key={fIndex} className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-[rgb(0,0,139)]/10 flex items-center justify-center shrink-0">
                      <i className="ri-check-line text-xs text-[rgb(0,0,139)]"></i>
                    </div>
                    <span className="text-gray-700 text-sm">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-[rgb(0,0,139)] rounded-2xl p-8 md:p-12 text-center">
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
            {t('whatWeDoCtaTitle')}
          </h3>
          <p className="text-white/80 text-lg max-w-2xl mx-auto mb-8">
            {t('whatWeDoCtaDescription')}
          </p>
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              const element = document.getElementById('contact');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="inline-flex items-center gap-2 bg-white text-[rgb(0,0,139)] px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t('startProject')}
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}